import * as ko from "knockout";
import * as mapping from "knockout.mapping";
import { NewspaperRequestStatusBlock } from "./newspaperRequestStatusBlock";

export class NewspaperRequestAddressBlock {
    Title: any;
    NewspaperRequestStatusBlocks: any;
    hasEditableTable: any;

    constructor(json?: any) {
        this.Title = ko.observable<string>();
        this.hasEditableTable = ko.observable<boolean>(false);
        this.NewspaperRequestStatusBlocks = ko.observableArray<NewspaperRequestStatusBlock>();

        if (json) {
            let mappingOptions = {
                'NewspaperRequestStatusBlocks': {
                    create: (args: any) => {
                        return new NewspaperRequestStatusBlock(args.data);
                    }
                }
            };

            mapping.fromJS(json, mappingOptions, this);
        }
    }
}